module.exports = __webpack_public_path__ + "img/logo_gestor.47d4f69f.png";